import dayjs from "dayjs";

export const DATE_FORMAT = "YYYY-MM-DD";
export const TODAY = dayjs().format(DATE_FORMAT);

export const MIN_DATE = "1900-01-01";
export const MIN_DAYJS = dayjs(MIN_DATE, DATE_FORMAT);
export const ONE_MONTH_AGO = dayjs().subtract(1, "month");
